import { useCallback, useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input, InputNumber, Select, message } from 'antd';
// import { FilterPayload, getAgentList } from 'api/agent';
import { FileExcelFilled } from '@ant-design/icons';
import xlsx from 'json-as-xlsx';
// import FilteredList from '../filterList/FilteredList';
// import { FilterPayload, getMandateStatusList, getNachList } from 'api/nach';
// import {  } from 'api/dashboard';

import moment from 'moment';
import { handleOnlyNumber } from 'features/nach/utils/handleOnlyNumber';
import FilteredList from '../filterList/FilteredList';
import {
  FilterPayload,
  getPaymentRequestHistoryList,
  SelectPayload,
  SelectResponse,
} from 'api/paymentRequestHistory';
import { getSelectList } from 'api/dashboard';

const dateFormat = 'DD/MM/YYYY';
type Props = {
  isLoading: boolean;
  onSubmit: (values: FilterPayload) => Promise<void>;
};

// const SourceApplicationName = sessionStorage.getItem('source')?.toString();

let filterPayload: FilterPayload = {};

function getFullDate(date: string) {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }
}
const initSelectResp: SelectResponse = {
  data: [],
};

const DashboardFilterForm = ({ onSubmit }: Props) => {
  const [form] = Form.useForm<FilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [_sourceId, setSourceId] = useState(0);
  const [sources, setSource] = useState(initSelectResp);
  const [status, setStatus] = useState(initSelectResp);
  const [paymentRequestType, setPaymentRequestType] = useState(initSelectResp);

  const [onlyDigitError, setOnlyDigitError] = useState(false);

  const { Option } = Select;

  console.log('Filetr ', filter);

  useEffect(() => {
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'PaymentRequestType,',
      };
      getSelectList(sourcePayload).then((res) => {
        setPaymentRequestType(res);
      });
    }
  }, []);

  useEffect(() => {
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'Source',
      };
      getSelectList(sourcePayload).then((res) => {
        setSource(res);
      });
    }
  }, []);

  useEffect(() => {
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'StatusSource',
      };
      getSelectList(sourcePayload).then((res) => {
        setStatus(res);
      });
    }
  }, []);

  const isAdmin = sessionStorage.getItem('isAdmin');

  const handleSubmit = useCallback(
    async (values: FilterPayload) => {
      let updatedValues = { ...values };

      Object.keys(updatedValues).forEach((key) => {
        const typedKey = key as keyof FilterPayload; // Cast the key to a valid key of FilterPayload
        if (updatedValues[typedKey] === '') {
          updatedValues[typedKey] = null as any; // Use type assertion
        }
      });

      if (updatedValues.fromDate) {
        updatedValues.fromDate = moment(updatedValues.fromDate).format('YYYY-MM-DD');
      }

      if (updatedValues.toDate) {
        updatedValues.toDate = moment(updatedValues.toDate).format('YYYY-MM-DD');
      }

      if (isAdmin != 'true') {
        updatedValues.sourceApplicationName = sessionStorage.getItem('source')?.toString();
      }

      setFilter(updatedValues);
    },
    [onSubmit]
  );
  // useEffect(() => {
  //   const statusPayload: SelectPayload = {
  //     SKey: 'BulkUploadStatus',
  //   };
  //   getSelectList(statusPayload).then((res) => {
  //     setStatus(res);
  //   });
  // }, []);
  function handleDownload(_e: any) {
    filter.isExtract = true;

    const filterValues: FilterPayload = form.getFieldsValue();

    // api is not working for it

    // filter.username = sessionStorage.getItem('user')?.toString();


    const fromDate = filterValues.fromDate;
    const toDate = filterValues.toDate;

    if (!fromDate || !toDate) {
      message.destroy();
      message.warning('Please Select From Date and To Date Within Range of 30 Days');
      return;
    }

    const diffDays = moment(toDate).diff(moment(fromDate), 'days');

    if (diffDays < 0) {
      message.destroy();
      message.warning('"To" date should be after "From" date.');
      return;
    }

    if (diffDays > 30) {
      message.destroy();
      message.warning('Please Select From Date and To Date Within Range of 30 Days');
      return;
    }
    // api is not working for it

    // filter.username = sessionStorage.getItem('user')?.toString();

    if (isAdmin != 'true') {
      filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    getPaymentRequestHistoryList(filter).then((_x) => {
      // console.log('Payment Request History', _x);
      let settings = {
        fileName: 'Payment Request History', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index: number) => ({
        ...item,
        RequestDate: getFullDate(item.RequestDate),
        ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'Request Id', value: 'RequestID' },
            { label: 'Payment Request Json', value: 'PaymentRequestJson' },
            { label: 'Payment Response Json', value: 'PaymentResponseJson' },
            { label: 'Request Type', value: 'RequestType' },
            { label: 'Request Date', value: 'RequestDate' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
    handleSubmit(filterPayload);
  }
  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };

  // function handleReset(_e: any) {
  //   form.resetFields();
  //   let updatedFilter = { ...filter };
  //   updatedFilter = filterPayload;
  //   setFilter(updatedFilter);
  //   setBankNameList([...bankNameList]);
  // }
  // console.log('Filter', filter);

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Payment Request Transition History</h2>
              <div className="submission-htmlForm">
                <Form<FilterPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Number :'} name="laNumber" className="fieldTitle">
                          <Input placeholder={'Enter Loan No'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Order Id:'} name="orderId" className="fieldTitle">
                          <Input placeholder={'Enter Order Id'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Status :'} name="requestStatus" className="fieldTitle">
                          <Select size="large" placeholder="Select" onSelect={handleSourceId}>
                            {status.data.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose'}
                          name="paymentPurpose"
                          className="fieldTitle"
                        >
                          <Select size="large" placeholder="Select">
                            <Option value="">Select</Option>
                            <Option value="ADVANCEEMI">ADVANCEEMI</Option>
                            <Option value="Crossell">Crossell</Option>
                            <Option value="Fees">Fees</Option>
                            <Option value="Foreclosure">Foreclosure</Option>
                            <Option value="OtherCharges">OtherCharges</Option>
                            <Option value="Overdue">Overdue</Option>
                            <Option value="OverdueWithoutCharges">OverdueWithoutCharges</Option>
                            <Option value="PartPayment">PartPayment</Option>
                            <Option value="VAS">VAS</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Request Purpose:'}
                          name="requestPurpose"
                          className="fieldTitle"
                        >
                          <Select size="large" placeholder="Select">
                            <Option value="Payment">Payment</Option>
                            <Option value="Receipt">Receipt</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Request Type:'}
                          name="requestType"
                          className="fieldTitle"
                        >
                          <Select size="large" placeholder="Select" onSelect={handleSourceId}>
                            {paymentRequestType.data.map((role) => (
                              <Option value={role.SText}>{role.SText}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Date From:'}
                          name="fromDate"
                          className="fieldTitle"
                        >
                          <DatePicker format={dateFormat} />
                          {/* <DatePicker format={'DD/MM/YYYY'} onSelect={handleDate} /> */}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'To :'} name="toDate" className="fieldTitle">
                          <DatePicker format={dateFormat} />
                          {/* <DatePicker format={'DD-MM-YYYY'} onSelect={handleDate} /> */}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Source Application Name :'}
                          name="sourceApplicationName"
                          className="fieldTitle"
                        >
                          <Select
                            placeholder="Select"
                            size="large"
                            // value={statusId.toString()}
                            onSelect={handleSourceId}
                          >
                            {/* <Option value="0">Select</Option> */}
                            {sources.data.map((role) => (
                              <Option value={role.SText}>{role.SText}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    {/* Need to remove column Bank Name, Request Status, Gateway Name, Payment ID Drop down
            SourceApplication(refer paymnet dashboard), Mandate Status,Mandate Type (Mode) */}
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Merchant ID :'} name="merchantID" className="fieldTitle">
                          <Input placeholder={'Merchant ID'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Reference No :'}
                          name="paymentRefNo"
                          className="fieldTitle"
                        >
                          <Input placeholder={'Payment Reference No'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Request ID :'}
                          name="paymentRequestID"
                          className="fieldTitle"
                          validateStatus={onlyDigitError ? 'error' : ''}
                          help={onlyDigitError ? 'Only numbers are allowed' : ''}
                        >
                          <InputNumber
                            value={form.getFieldValue('PaymentRequestId')}
                            onBeforeInput={(e) => handleOnlyNumber(e, setOnlyDigitError)}
                            placeholder={'Payment Request ID:'}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Search Text :'} name="searchText" className="fieldTitle">
                          <Input placeholder={'Search Text'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Payment Id :'} name="paymentId" className="fieldTitle">
                          <Input placeholder={'PaymentId'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div style={{ float: 'right', marginBottom: '10px', marginTop: '30px' }}>
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ float: 'right', fontSize: '30px', color: 'green' }}
                        onClick={handleDownload}
                      ></Button>
                      &nbsp; &nbsp;
                      <Button
                        type="primary"
                        onClick={handleReset}
                        style={{ float: 'right', marginRight: '5px' }}
                      >
                        {'CLEAR'}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right', marginRight: '10px' }}
                      >
                        {'SEARCH'}
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
              <FilteredList filter={{ ...filter }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DashboardFilterForm;
